import { socket } from "../socket.js";

export function send(message) {
  console.log("emit");

  socket.emit("mensaje", message);
}

export function disconnect() {
  socket.disconnect();
}

// export class SocketService {
//   const socket;
//   const SERVER_URL;

//   constructor(private _globals: GlobalsService) {
//     this.SERVER_URL = _globals.ioServer;
//   }

//   public initSocket(params?: string): void {
//     this.socket = socketIo(this.SERVER_URL, { query: params });
//   }

//   public send(message: Message): void {
//     this.socket.emit("message", message);
//   }

//   public onMessage(): Observable<Message> {
//     return new Observable<Message>((observer) => {
//       this.socket.on("message", (data: Message) => observer.next(data));
//     });
//   }

//   public onEvent(event: Event): Observable<any> {
//     return new Observable<Event>((observer) => {
//       this.socket.on(event, () => observer.next());
//     });
//   }
// }
